import { PageWrapper } from '../../shared';
import { userModel } from 'entities/user';
import { useDispatch } from 'react-redux';
import { useWeb3Provider } from '../../shared/config/wallet-connect';
import { useEffect } from 'react';
import { Buy } from '../../widgets/buy';

export const BuyPage = () => {
  const dispatch = useDispatch();
  const web3Provider = useWeb3Provider();

  useEffect(() => {
    dispatch(userModel.userActions.getBuyInfo({ web3Provider }));
  }, [dispatch, web3Provider]);

  return (
    <PageWrapper title="Buy MOGUL TOKENS" subTitle="Fast Purchase, Infinite Possibilities ">
      <Buy />
    </PageWrapper>
  );
};
